// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var constants = require('logic/data/Izenda.ReportsConstants');
  var convertToNumeralFormat = require('share/utils/Izenda.ConvertToNumeralFormat');

  function ReportDetail(data) {
    // do not need to observer
    this.reportDataSource = [];

    var props = {
      id: '0',
      name: '',
      type: constants.CATEGORY_TYPE.REPORT,
      previewRecord: 0,
      advancedMode: false,
      allowNulls: false,
      isDistinct: false,
      categoryId: null,
      categoryName: null,
      subCategoryId: null,
      subCategoryName: null,
      tenantId: null,
      description: null,
      createdBy: null,
      created: null,
      modifiedBy: null,
      version: 0,
      numberOfView: 0,
      renderingTime: 0,
      owner: null,
      lastView: null,
      state: 0,
      modified: null,
      dateTimeNow: null,
      isShowDetail: false,
      lastViewed: null,
      isSubscribeMode: false,
      deletable: true,
      copyable: true,
      movable: true,
      accessPriority: null,
      checked: false,
      indeterminate: false,
      isGlobal: false,
      allowToSave: false,

      isEmpty: function() {
        return this.id === constants.EMPTY_GUID;
      },
      renderingTimeInSeconds: function() {
        return convertToNumeralFormat('0.00', this.renderingTime / 1000) + ' s';
      }
    };

    m.extendObservable(this, props);

    data && this.populateData(data);
  }

  ReportDetail.prototype.populateData = m.action(function(data) {
    data = data || {};

    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.previewRecord = data.previewRecord;
    this.advancedMode = data.advancedMode;
    this.allowNulls = data.allowNulls;
    this.isDistinct = data.isDistinct;
    this.categoryId = data.categoryId;
    this.categoryName = data.categoryName;
    this.subCategoryId = data.subCategoryId;
    this.subCategoryName = data.subCategoryName;
    this.tenantId = data.tenantId;
    this.description = data.description;
    this.createdBy = data.createdBy;
    this.created = data.created;
    this.modifiedBy = data.modifiedBy;
    this.version = data.version;
    this.numberOfView = data.numberOfView;
    this.renderingTime = data.renderingTime;
    this.owner = data.owner;
    this.lastView = data.lastView;
    this.state = data.state;
    this.modified = data.modified;
    this.dateTimeNow = data.dateTimeNow;
    this.isShowDetail = data.isShowDetail || false;
    this.lastViewed = data.lastViewed;
    this.isEditMode = false;
    this.deletable = data.deletable;
    this.copyable = data.copyable;
    this.movable = data.movable;
    this.accessPriority = data.accessPriority;
    this.checked = data.checked;
    this.isGlobal = data.isGlobal;
    this.allowToSave = data.allowToSave;

    this.reportDataSource = data.reportDataSource;
  });

  ReportDetail.prototype.setStateExpanded = function(state) {
    this.isShowDetail = state;
  };

  ReportDetail.prototype.setReportName = function(name) {
    this.name = name;
  };

  /**
   * check if this field will be highlighted or not
   * @param {Object} searchType
   * @param {Object} field
   * @returns {Promise}
   */
  ReportDetail.prototype.isNotHighLight = function(searchType, field) {
    return searchType !== constants.SEARCH_CRITERIA[0].value && searchType !== field;
  };

  /**
   * Set edit mode
   * @param {boolean} isEditMode
   */
  ReportDetail.prototype.setEditMode = function(isEditMode) {
    this.isEditMode = isEditMode;
  };

  /**
   * Toggle subscribe mode
   */
  ReportDetail.prototype.toggleSubscribeMode = function() {
    this.isSubscribeMode = !this.isSubscribeMode;
  };

  module.exports = ReportDetail;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportDetail.js